import React from 'react'

import { gettext } from '../../../../services'

const t = {
    SORT_BY: gettext('Sort by'),
}

/**
 * @typedef {Object} FilterButtonProps
 * @property {boolean} filtersShown
 * @property {(showFilters: boolean) => void} onClick
 */

/**
 * Search app header with info and controls for the results list.
 * @param {Object} props
 * @param {() => React.ReactNode} props.renderResultsCount
 * @param {() => React.ReactNode} [props.renderSortField]
 * @param {(props: FilterButtonProps) => React.ReactNode} props.renderFiltersButton
 * @param {boolean} props.filtersShown
 * @param {(showFilters: boolean) => void} props.onFiltersClick Click handler for the filters button
 */
const SearchHeader = ({
    renderResultsCount, renderSortField, renderFiltersButton, filtersShown, onFiltersClick,
}) => (
    <header className="search-header">
        <div className="text-left">
            {renderResultsCount()}
        </div>
        {renderSortField && (
            <div className="sort-field">
                <span className="hidden-xs">{t.SORT_BY + ' '}</span>
                {renderSortField()}
            </div>
        )}
        <div className="text-right">
            {renderFiltersButton({
                filtersShown,
                onClick: onFiltersClick,
            })}
        </div>
    </header>
)

export default SearchHeader
